export const ExternalSwitches = {
  WEB_ATTRIBUTION_SURVEY: "web_attribution_survey",
  WEB_EXTERNAL_SHRINK_ROLE_BUTTONS: "web_external_shrink_role_buttons_v3",
  WEB_EXTERNAL_PARENTS_FIRST: "web_external_parents_first_v2",
  WEB_EXTERNAL_MOBILE_A_A: "web_external_mobile_a_a_v2",
  WEB_EXTERNAL_HOMEPAGE_BR: "web_external_homepage_br_experiment",
  WEB_EXTERNAL_HOMEPAGE_TR: "web_external_homepage_tr_experiment",
  WEB_EXTERNAL_CLASSROOM_MGMT_BR_TR: "web_external_classroom_mgmt_br_tr",
  WEB_EXTERNAL_AI_SUPPORT: "web_external_ai_support",
  WEB_EXTERNAL_USER_SURVEY: "web_external_user_survey",
  WEB_EXTERNAL_LOGIN_SIGNUP_TEACHER: "web_external_teacher_combined_signup",
  WEB_EXTERNAL_LOGIN_SIGNUP_SL: "web_external_sl_combined_signup",
  WEB_EXTERNAL_TEACHER_LOGIN_VIA_CODE: "web_external_teacher_login_via_code",
  WEB_EXTERNAL_SL_LOGIN_VIA_CODE: "web_external_sl_login_via_code",
} as const;

export const featureSwitches = Object.values(ExternalSwitches);
